module.exports = __webpack_public_path__ + "img/qqsg_logo.ba2ebdf7.png";